<template>
  <!-- Collect borrower details -->
  <a-card :bordered="false">
    <a-row :gutter="24">
      <a-col :span="5">
        <div class="form-item">
          <span class="form-label">{{ $t('platformCollection.fee_details_collection_time') }}:</span>
          <a-range-picker
            :label="$t('platformCollection.fee_details_collection_time')"
            v-model:value="dateRange"
            :format="dateFormat"
            style="width: 100%"
            format="DD-MM-YYYY"
          />
        </div>
      </a-col>

      <a-col :span="5">
        <div class="form-item">
          <a-input-group compact>
            <a-select default-value="jack" style="width: 100px" @change="handleChange">
              <a-select-option value="jack">{{ $t('platformCollection.fee_details_account') }}</a-select-option>
              <a-select-option value="lucy">{{ $t('platformCollection.fee_details_name') }}</a-select-option>
            </a-select>
            <a-input
              v-model:value="searchValue"
              :placeholder="
                searchType === 'mobile'
                  ? $t('platformCollection.fee_details_please_enter_account')
                  : $t('platformCollection.fee_details_please_enter_name')
              "
              style="width: calc(100% - 100px)"
            ></a-input>
          </a-input-group>
        </div>
      </a-col>

      <a-col :span="4">
        <div class="form-item">
          <span class="form-label">{{ $t('platformCollection.fee_details_fee_name') }}:</span>
          <dict-select
            v-model="feeNameCode"
            :dict-code="DICT_CODE.PLATFORMFEENAMELIST"
            :begin="[{ value: '', label: $t('platformCollection.fee_details_all'), labelEn: 'All', labelEs: 'Tất cả' }]"
          />
        </div>
      </a-col>

      <a-col :span="6">
        <div class="form-item">
          <span class="form-label">{{ $t('platformCollection.fee_details_collection_node') }}:</span>
          <dict-select
            v-model="feePoint"
            :dict-code="DICT_CODE.PLATFORMFEEPOINT"
            :begin="[{ value: '', label: $t('platformCollection.fee_details_all'), labelEn: 'All', labelEs: 'Tất cả' }]"
          />
        </div>
      </a-col>

      <a-col :span="2">
        <a-button type="primary" @click="search">{{ $t('platformCollection.fee_details_query') }}</a-button>
      </a-col>
    </a-row>
    <a-table
      :columns="i18nColumns"
      :data-source="data"
      :pagination="paginationState"
      :loading="loading"
      bordered
      style="margin-top: 26px"
    >
      <span slot="feeName" slot-scope="text">
        <Dict :dict-code="DICT_CODE.PLATFORMFEENAMELIST" :value="String(text)" />
      </span>
      <span slot="collectionNode" slot-scope="text">
        <Dict :dict-code="DICT_CODE.PLATFORMFEEPOINT" :value="String(text)" />
      </span>
      <span slot="feeAmount" slot-scope="text">
        {{ text | FenToDong }}
      </span>
      <span slot="feeRate" slot-scope="text">
        {{ text ? (text * 100) + '%' : '-' }}
      </span>
      <span slot="createdTime" slot-scope="text">
        {{ text ? formatDateDisplay(text) : '-' }}
      </span>
    </a-table>
  </a-card>
</template>

<script>
import moment from 'moment'
import { platformRevenueFlowList } from '@/webpublicapi/vietnamBackstage'
import DictSelect from '@/views/webpublic/modules/DictSelect'
import Dict from '@/views/webpublic/modules/Dict'
import DICT_CODE from '@/constants/dict-code'

const columns = [
  {
    title: 'fee_details_borrower_name',
    dataIndex: 'custName',
    align: 'center',
  },
  {
    title: 'fee_details_account',
    dataIndex: 'mobileNo',
    align: 'center',
  },
  {
    title: 'fee_details_fee_name_title',
    dataIndex: 'feeNameCode',
    align: 'center',
    scopedSlots: { customRender: 'feeName' },
  },
  {
    title: 'fee_details_collection_node_title',
    dataIndex: 'feePoint',
    align: 'center',
    scopedSlots: { customRender: 'collectionNode' },
  },
  {
    title: 'fee_details_collection_standard',
    dataIndex: 'feeRate',
    align: 'center',
    scopedSlots: { customRender: 'feeRate' },
  },
  {
    title: 'fee_details_receivable_amount',
    dataIndex: 'feeAmount',
    align: 'center',
    scopedSlots: { customRender: 'feeAmount' },
  },
  {
    title: 'fee_details_actual_amount',
    dataIndex: 'feeAmount',
    align: 'center',
    scopedSlots: { customRender: 'feeAmount' },
  },
  {
    title: 'fee_details_collection_time_title',
    dataIndex: 'createdTime',
    align: 'center',
    scopedSlots: { customRender: 'createdTime' },
  },
]

export default {
  name: 'CollectFromBorrowers',
  components: { DictSelect, Dict },
  data() {
    return {
      DICT_CODE,
      dateFormat: 'YYYY/MM/DD',
      monthFormat: 'YYYY/MM',
      dateFormatList: ['DD/MM/YYYY', 'DD/MM/YY'],
      data: [],
      columns,
      paginationState: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `${this.$t('components.total')} ${total} ${this.$t('components.items')}`,
        pageSizeOptions: ['10', '20', '50', '100'],
        onChange: (current, pageSize) => {
          this.paginationState.current = current
          this.paginationState.pageSize = pageSize
          this.search()
        },
      },
      dateRange: [],
      searchType: 'mobile',
      searchValue: '',
      feeNameCode: '',
      feePoint: '',
      loading: false,
    }
  },
  computed: {
    i18nColumns() {
      return this.columns.map((col) => ({
        ...col,
        title: this.$t('platformCollection.' + col.title),
      }))
    },
  },
  mounted() {
    this.search()
  },
  methods: {
    moment,
    handleChange(value) {
      this.searchType = value === 'jack' ? 'mobile' : 'realName'
    },
    search() {
      this.loading = true
      const params = {
        pageNum: this.paginationState.current,
        pageSize: this.paginationState.pageSize,
      }

      if (this.searchValue && this.searchType === 'mobile') {
        params.mobileNo = this.searchValue
      }

      if (this.feeNameCode) {
        params.feeNameCode = Number(this.feeNameCode)
      }

      if (this.feePoint) {
        params.feePoint = Number(this.feePoint)
      }

      if (this.dateRange && this.dateRange.length === 2) {
        params.startDate = moment(this.dateRange[0]).format('YYYY-MM-DD')
        params.endDate = moment(this.dateRange[1]).format('YYYY-MM-DD')
      }

      platformRevenueFlowList(params)
        .then((res) => {
          if (res && res.code === 1000 && res.data) {
            this.data = res.data.rows || []
            this.paginationState.total = res.data.total || 0
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
    },
    formatDateDisplay(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp)
      if (isNaN(date.getTime())) return timestamp
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';

.form-item {
  display: flex;
  align-items: center;
  gap: 8px;

  .form-label {
    // min-width: 80px;
    text-align: right;
    white-space: nowrap;
    flex-shrink: 0;
  }

  :deep(.dict-select-wrapper) {
    flex: 1;
  }

  :deep(.ant-input),
  :deep(.ant-select),
  :deep(.ant-picker) {
    flex: 1;
  }
}
</style>
